<template>
    <div class="container-item-wrapper">
        <AddRefCoverPanel
            class="addcover-panel-container"
            :no-cover-icon="noCoverIcon"
            :image-url="data.cardImage"
            :operate-icons="operateIcons"
            :view-icon="viewIcon"
            :ishorizontal="true"
            :needClip="true"
            :aspectRatio="1 / 1"
            @change="cardImageChange"
        />
        <IconInput :placeholder="inputDescLabel" class="container-input" :initValue="data.name" @inputChange="descChange" />
        <HotPointPanel :data="hotPointData" @redSwitch="redSwitch" @hotSwitch="hotSwitch" @endDateChange="hotDateChange" />
        <div class="relation-question-wrapper">
            <div class="c-relation-question">
                <span class="relation-question" @mouseover="mouseOnQuestion" @mouseout="mouseOutQuestion" @click="questionClick">
                    {{ data.question || defaultQuestion }}
                </span>
            </div>
            <QuestionSimpleView
                class="question-view"
                v-if="showSimple"
                :content="simpleContent"
                :questionId="data.questionId"
                @onview="mouseOnQuestion"
                @outview="mouseOutQuestion"
            />
        </div>
        <TransferIcon class="opr-transfer" @transfer="tranferItem" />
        <DeleteIcon class="opr-delete" @iconClick="deleteItem" />
    </div>
</template>

<script>
import IconInput from "@/views/zhiji/bComponents/inputs/IconInput";
import HotPointPanel from "../HotPointPanel";
import QuestionSimpleView from "../../options/QuestionSimpleView";
import TransferIcon from "@/views/zhiji/bComponents/icons/TransferIcon";
import DeleteIcon from "@/views/zhiji/bComponents/icons/DeleteIcon";
import AddRefCoverPanel from '@/views/zhiji/components/coverPanel/AddRefCoverPanel.vue';
import i18n from "@/i18n";

export default {
    name: "ContainerItem",
    props: ["data", "parentUId"],
    components: {
        IconInput,
        HotPointPanel,
        QuestionSimpleView,
        TransferIcon,
        DeleteIcon,
        AddRefCoverPanel
    },
    data() {
        return {
            isShowSimple: false,
            simpleContent: "",
            viewIcon: {
                position: '-172px -74px',
                isShowIcon: true,
            }
        };
    },
    computed: {
        showSimple() {
            return this.isShowSimple && !!this.simpleContent;
        },
        hotPointData() {
            return {
                redState: this.data.redState,
                hotItem: this.data.hotItem,
                endTime: this.data.redHotEndTime
            };
        },
        inputDescLabel() {
            return this.$t("zhiji.answer.inputDesc");
        },
        defaultQuestion() {
            return this.$t("zhiji.answer.textWidget.linkQuestion");
        },
        noCoverIcon() {
            return {
                position: "-145px -50px",
                label: this.$t("zhiji.answer.uploadIcon")
            };
        },
        operateIcons() {
            return [
                {
                    type: "update",
                    position: "-38px -77px",
                    name: this.$t("zhiji.answer.replaceIcon")
                }
            ];
        }
    },
    methods: {
        mouseOnQuestion() {
            this.simpleTimeout && clearTimeout(this.simpleTimeout);
            this.simpleTimeout = setTimeout(() => {
                this.isShowSimple = true;

                this.data.questionId &&
                    this.zhiji
                        .requestByServiceName("queryQuesSimpleById", {
                            questionId: this.data.questionId
                        })
                        .then(resp => {
                            this.simpleContent = resp.answerText;
                        });
            }, 500);
        },
        tranferItem(event) {
            this.zhiji.dragStart(event, "h-list-item", "h", newIdx => {
                this.$store.commit("zhiji/editQsUpdateAnswer", {
                    type: "tranferContentItem",
                    widget: {
                        uId: this.parentUId,
                        item: {
                            newIdx: newIdx,
                            uId: this.data.uId
                        }
                    }
                });
            });
        },
        deleteItem() {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: this.$t("zhiji.answer.delCardTips"),
                    cancel: () => {},
                    confirm: () => {
                        this.$store.commit("zhiji/editQsUpdateAnswer", {
                            type: "deleteContentItem",
                            widget: {
                                uId: this.parentUId,
                                item: {
                                    uId: this.data.uId
                                }
                            }
                        });
                    }
                }
            });
        },
        descChange(newVal) {
            this.commitUpdate({
                name: newVal
            });
        },
        redSwitch(redState) {
            this.commitUpdate({
                redState: redState
            });
        },
        hotSwitch(hotItem) {
            this.commitUpdate({
                hotItem: hotItem
            });
        },
        hotDateChange(dateStr) {
            this.commitUpdate({
                redHotEndTime: dateStr
            });
        },
        cardImageChange({ value }) {
            this.commitUpdate({
                cardImage: value
            });
        },
        mouseOutQuestion() {
            this.simpleTimeout && clearTimeout(this.simpleTimeout);
            this.simpleTimeout = setTimeout(() => {
                this.isShowSimple = false;
            }, 500);
        },
        questionClick() {
            this.$store.dispatch("zhiji/showModal", {
                type: "QuestionSelectorTableModal",
                data: {
                    title: i18n.t("zhiji.answer.textWidget.linkQuestion"),
                    questionId: parseInt(this.data.questionId),
                    currentLang: this.$store.state.zhiji.questionEdit.currentSynonym,
                    confirm: data => {
                        this.questionSelected(data);
                    }
                }
            });
        },
        questionSelected(data) {
            if (!data.question) {
                return;
            }
            let relationQuestion = {
                question: data.question,
                questionId: data.questionId,
                uId: this.data.uId,
                name: data.optionTip,
            };
            this.commitUpdate(relationQuestion);
        },
        commitUpdate(updateData) {
            updateData.uId = this.data.uId;
            this.$store.commit("zhiji/editQsUpdateAnswer", {
                type: "updateContentItem",
                widget: {
                    uId: this.parentUId,
                    item: updateData
                }
            });
        }
    },
};
</script>

<style lang="less" scoped>
.container-item-wrapper {
    position: relative;
    background: #fff;
    border: 1px solid #d8e4f0;
    border-radius: 4px;
    margin-right: 16px;
    font-size: 12px;
    width: 200px;
    flex-shrink: 0;

    .addcover-panel-container{
        width: 200px;
        height: 107px;
        border: none;
    }
    .container-input {
        width: 200px;
    }
    .relation-question-wrapper {
        border-top: 1px solid #d8e4f0;
        position: relative;
        box-sizing: border-box;
    }

    .opr-transfer {
        display: none;
        z-index: 1;
        top: -21px;
        left: -2px;
        position: absolute;
    }

    .opr-delete {
        display: none;
        z-index: 1;
        right: -9px;
        top: -9px;
        position: absolute;
    }

    &:hover {
        .opr-transfer {
            display: inline-flex;
        }

        .opr-delete {
            display: inline-block;
        }
    }
    .container-item-icon {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 200px;
        height: 200px;
        background: #fafbfd;
        border-radius: 4px 4px 0px 0px;
        cursor: pointer;

        &:hover {
            color: #2ec2ff;

            .item-icon {
                background-position-y: -74px !important;
            }
        }
    }

    .c-relation-question {
        padding: 12px 0;
        text-align: center;

        .relation-question {
            display: block;
            background: #ffffff;
            border: 1px solid #d8e4f0;
            border-radius: 20px;
            width: 175px;
            height: 32px;
            margin: 0 auto;
            padding: 0 8px;
            box-sizing: border-box;
            line-height: 32px;
            text-align: center;
            cursor: pointer;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            &:hover {
                color: #2ec2ff;
            }
        }
    }

    .question-view {
        top: 35px;
        left: -40px;
    }
}
</style>
